module.exports = __webpack_public_path__ + "img/requirements.6750022f.svg";